import { Controller } from "@hotwired/stimulus"

// The Pinned section of a project's page shows two items per row (the default) or one per row, switched from the two small
// buttons at its top right. The reader's choice is remembered in this browser, for every project.
const KEY = "emailpa-hub-pinned-layout"

export default class extends Controller {
    static targets = ["button"]

    connect() {
        let saved = null
        try {
            saved = window.localStorage.getItem(KEY)
        } catch (_error) {
            /* a private window still switches, it just forgets */
        }
        this.apply(saved === "list" ? "list" : "grid")
    }

    set(event) {
        const layout = event.currentTarget.dataset.layout === "list" ? "list" : "grid"
        try {
            window.localStorage.setItem(KEY, layout)
        } catch (_error) {
            /* see connect */
        }
        this.apply(layout)
    }

    apply(layout) {
        this.element.classList.toggle("is-grid", layout === "grid")
        this.element.classList.toggle("is-list", layout === "list")
        this.buttonTargets.forEach((button) => {
            const on = button.dataset.layout === layout
            button.classList.toggle("is-active", on)
            button.setAttribute("aria-pressed", String(on))
        })
    }
}
